import { ShipmentType } from '@views/Shipments/types';
import { ChangeEvent, useState } from 'react';
import { useDebouncedQuery } from './useDebouncedQuery';

export const useShipmentFilter = () => {
  const {
    query,
    setDebouncedQuery,
    debouncedQuery: searchFilter,
  } = useDebouncedQuery();
  const [shipmentType, setShipmentType] = useState<ShipmentType>('Inbound');
  const [dateFrom, setDateFrom] = useState('');
  const [dateTo, setDateTo] = useState('');
  const [exceptionsOnly, setExceptionsOnly] = useState(false);

  const handleChangeSearchFilter = (event: ChangeEvent<HTMLInputElement>) =>
    setDebouncedQuery(event.target.value);

  const handleChangeDateFrom = (event: ChangeEvent<HTMLInputElement>) =>
    setDateFrom(event.target.value);

  const handleChangeDateTo = (event: ChangeEvent<HTMLInputElement>) =>
    setDateTo(event.target.value);

  return {
    query,
    searchFilter,
    handleChangeSearchFilter,
    shipmentType,
    setShipmentType,
    dateFrom,
    handleChangeDateFrom,
    dateTo,
    handleChangeDateTo,
    exceptionsOnly,
    setExceptionsOnly,
  };
};
